import React from 'react';
import CustomModal from '../../baseComponents/gui/customModal/CustomModal';
import { useModal } from '../../../hooks/useModal';
import CustomButton from '../../features/customButton/ui/main/CustomButton';
import { safeHTML } from '../../../utils/safeHTML';
import { useTranslation } from '../../../translations';

const GameRatingModal = React.forwardRef(function GameRatingModal({ image, date, text, button }, ref) {
  const { closeModal, id } = useModal();
  const { t } = useTranslation();

  return (
    <CustomModal>
      <div className={'game-rating-modal'} ref={ref}>
        <div className={`game-rating-modal__image-box`}>
          <img src={image} alt={''} />
        </div>
        <p className={`game-rating-modal__date`}>
          {safeHTML(t('gameRatingModal.date', { start: date.start, end: date.end }))}
        </p>
        <p className={`game-rating-modal__text`}>{safeHTML(t(text))}</p>
        <CustomButton {...button} onClick={() => closeModal(id)} />
      </div>
    </CustomModal>
  );
});
export default GameRatingModal;
GameRatingModal.propTypes = {};
